import MobilePillowsSection from './MobilePillowsSection';

export default MobilePillowsSection;
